/**
 * @file render处理
 * @author lixiang<lixiang02@baijia.com>
 */
import {Select} from 'lark';

const {Option} = Select;

/**
 * 生成select组件的options
 *
 * @param {array} list 输入的字符
 * @return {node} 生成的option列表
 */
// eslint-disable-next-line import/prefer-default-export
export const renderSelectOptions = (list, keyName = 'value', valueName = 'label') => {
    if (list && list.length) {
        return list.map(item => (
            <Option key={item[keyName]} value={item[keyName]}>
                {item[valueName]}
            </Option>
        ));
    }
    return [];
};
